export default "__VITE_ASSET__12de02b2__"